import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductCard from './ProductCard';
import '../styles/PageHome.css';

function PageHome() {
	const [latestProducts, setLatestProducts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	// Fetch latest products on mount
	useEffect(() => {
		const fetchLatestProducts = async () => {
			try {
				const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/products/latest`);
				setLatestProducts(response.data);
			} catch (error) {
				console.error("Błąd pobierania nowości:", error);
				setError("Wystąpił błąd podczas ładowania nowości.");
			} finally {
				setLoading(false);
			}
		};

		fetchLatestProducts();
	}, []);

	return (
		<div className="home">
			<div className="overlay">
				<header className="hero">
					<h1>Witaj w naszym sklepie!</h1>
					<p>
						Nasza firma specjalizuje się w sprzedaży wysokiej jakości sztucznych kwiatów,
						ozdobnych gałązek, główek, liści oraz innych półproduktów wykorzystywanych do tworzenia wyjątkowych kompozycji florystycznych.
					</p>
				</header>

				<section className="featured">
					<h2>Nowości</h2>
					<div className="product-list">
						{loading ? (
							<p>Ładowanie nowości...</p>
						) : error ? (
							<p>{error}</p>
						) : latestProducts.length > 0 ? (
							latestProducts.map((product) => (
								<ProductCard key={product._id} product={product} />
							))
						) : (
							<p>Brak nowych produktów.</p>
						)}
					</div>
				</section>

				<section className="aboutUs">
					<h2>Kim jesteśmy?</h2>
					<p>
Jesteśmy rodzinną firmą z małopolski na pograniczu Podhala i Beskidu Wyspowego. Zajmujemy się sprzedażą kwiatów sztucznych i dodatków. W swojej pracy stawiamy na jakość. Śledzimy bieżące trendy z branży dzięki czemu możemy dać Wam szansę na tworzenie modnych i wyjątkowych rzeczy. Nasze kwiaty i dodatki świetnie sprawują się w dekoracjach okolicznościowych (na przyklad wianki, stroiki, bukiety), ale również w kompozycjach nagrobnych. Dzięki możliwości sprzedaży i wysyłki na terenie UE nie ma dla nas granic!
					</p>
				</section>
			</div>
		</div>
	);
}

export default PageHome;
